import {
	Breakpoints,
	Layout,
	LayoutRowGap,
	Text,
	TokenTextAppearance,
} from '@volkswagen-onehub/components-core';
import React from 'react';
import {
	CarlineSelect,
	DetalleMotivo,
	InicioEncuesta,
	MultipleCTASelection,
	NombreApellidos,
	RatingStars,
} from 'src/components';
import { RadioTextGroup } from 'src/components/inputs/RadioTextGroup';
import { CTAsSiNo } from 'src/feature-app/InputsValues';
import { ConfirmacionCem } from 'src/forms/Cem/ConfirmacionCem';
import { Steps } from 'src/types';
import {
	valueWrongConcesion,
	valueWrongMarca,
	valueWrongModelo,
	valueWrongPersona,
} from '../helpers/data';
import { FirstStepCEMVentaProducto } from './FirstStepCEMVentaProducto';

function LayoutTemplate(props: any) {
	const { element } = props;

	return (
		<Layout
			allowOverflowingContent
			appearance={{
				[Breakpoints.default]: [
					{ name: '.', columns: 2 },
					{ name: 'a', columns: 20 },
					{ name: '.', columns: 2 },
				],
				[Breakpoints.b960]: [
					{ name: '.', columns: 3 },
					{ name: 'a', columns: 18 },
					{ name: '.', columns: 3 },
				],
				[Breakpoints.b1280]: [
					{ name: '.', columns: 5 },
					{ name: 'a', columns: 14 },
					{ name: '.', columns: 5 },
				],
				[Breakpoints.b1920]: [
					{ name: '.', columns: 6 },
					{ name: 'a', columns: 12 },
					{ name: '.', columns: 6 },
				],
				[Breakpoints.b2560]: [
					{ name: '.', columns: 7 },
					{ name: 'a', columns: 10 },
					{ name: '.', columns: 7 },
				],
			}}
			rowGap={LayoutRowGap.static300}
		>
			{element}
		</Layout>
	);
}

export const getStepsVentaProducto = (
	isElectrico: boolean,
	installation: string,
	modelo?: string,
) => {
	let index = 0;

	const ctaDatosIncorrectos = [
		{
			label: 'Marca incorrecta',
			value: valueWrongMarca.toString(),
		},
		{
			label: 'Modelo incorrecto',
			value: valueWrongModelo.toString(),
		},
		{
			label: 'Punto de venta incorrecto',
			value: valueWrongConcesion.toString(),
		},
		{
			label: 'Persona de contacto incorrecta',
			value: valueWrongPersona.toString(),
		},
	];

	const optionsEnviarConcesion = [
		{
			value: '1',
			label: 'Sí, mis respuestas pueden ser enviadas y analizadas junto a mi nombre y al número de bastidor de mi vehículo, para el alcance descrito anteriormente (el consentimiento puede revocarse en cualquier momento a través de los canales de contacto que se indican a continuación*)',
			info: '*Puedo revocar este consentimiento en cualquier momento sin dar motivos a mi Distribuidor para mis datos personalizados.',
		},
		{
			value: '2',
			label: 'Mis respuestas pueden ser enviadas pero sin mencionar mi nombre ni el bastidor del vehículo (seleccionando esta opción, el Servicio Oficial no podrá ponerse en contacto contigo en relación a tus comentarios).',
			info: 'Seleccionando esta opción, el punto de venta no podrá ponerse en contacto contigo en relación a tus comentarios.',
		},
		{
			value: '0',
			label: 'No, mis respuestas solo deben ser analizadas de manera anónima (seleccionando esta opción, tus respuestas serán analizadas de modo agregado junto al resto de respuestas de todos los entrevistados y no se trasladarán a los comentarios abiertos)',
			info: 'Seleccionando esta opción, tus respuestas serán analizadas de modo agregado junto al resto de respuestas de todos los entrevistados y no se trasladarán a los comentarios abiertos.',
		},
	];

	const ctaGruposCliente = [
		{
			label: 'Cliente particular con vehículo própio (con o sin financiación)',
			value: '1',
		},
		{
			label: 'Cliente particular con vehículo renting ',
			value: '2',
		},
		{
			label: 'Cliente de empresa con vehículo própio (con o sin financiación)',
			value: '3',
		},
		{
			label: 'Cliente de empresa con vehículo renting',
			value: '4',
		},
		{
			label: 'Conductor de coche de empresa con vehículo de renting',
			value: '5',
		},
		{
			label: 'Conductor de coche de empresa con otro tipo de mobilidad',
			value: '6',
		},
		{
			label: 'Otro grupo de clientes',
			value: '7',
		},
	];

	const firstStep = {
		fields: <FirstStepCEMVentaProducto />,
		screenIndex: index++,
		name: 'isDatosCorrectos',
		alternateTitle: (
			<Text>¿Puedes confirmar que estos datos son correctos?</Text>
		),
		outputs: ['isDatosCorrectos'],
		outputsText: ['isDatosCorrectos'],
		trueOrFalsequestion: true,
	};

	const confirmacionDatos = {
		title: (
			<>
				Por favor,{' '}
				<Text bold>¿puedes confirmarnos qué dato no es correcto?</Text>
			</>
		),
		fields: (
			<LayoutTemplate
				element={
					<MultipleCTASelection
						ctaValues={ctaDatosIncorrectos}
						name="datoIncorrecto"
						nextOnClick
					/>
				}
			/>
		),
		screenIndex: index++,
		name: 'datoIncorrecto',
		outputs: ['datoIncorrecto'],
		outputsText: ['datoIncorrecto'],
		ctas: ctaDatosIncorrectos,
	};

	const confirmacionConcesion = {
		title: (
			<Text bold>¿Has comprado tu nuevo coche en {installation}?</Text>
		),
		fields: (
			<LayoutTemplate
				element={
					<MultipleCTASelection
						ctaValues={CTAsSiNo}
						name="confirmacionConcesion"
						nextOnClick
						ctaWidth="81"
					/>
				}
			/>
		),
		screenIndex: index++,
		name: 'confirmacionConcesion',
		outputs: ['confirmacionConcesion'],
		outputsText: ['confirmacionConcesion'],
	};

	const seleccionModelo = {
		title: <Text bold>¿Cuál es el modelo correcto?</Text>,
		fields: (
			<LayoutTemplate
				element={
					<div>
						<CarlineSelect isCEMVenta={true} useCarline={true} />
					</div>
				}
			/>
		),
		screenIndex: index++,
		name: 'seleccionModelo',
		outputs: ['seleccionModelo'],
		outputsText: ['seleccionModelo'],
	};

	const inicioRating = {
		title: (
			<>
				A continuación, por favor,{' '}
				<Text bold>
					indica tu nivel de satisfacción con aspectos de tu nuevo
					coche.
				</Text>
			</>
		),
		fields: (
			<InicioEncuesta bodyCopy="Valora del 1 al 5, a mayor número de estrellas más satisfacción." />
		),
		screenIndex: index++,
		name: 'inicioRating',
	};

	const preguntaMotivo = (
		<Text bold>¿Cuál es la razón por la que has dado esta puntuación?</Text>
	);
	const recomendacionMotivo =
		'Por favor, no menciones nombres propios, direcciones, números de teléfono o descripciones que permitan identificarte a ti o a nuestros empleados.';

	const satisfaccionInterior = {
		title: (
			<Text bold>
				¿Qué valoración darías al diseño y materiales del interior del
				vehículo?
			</Text>
		),
		fields: (
			<LayoutTemplate
				element={
					<RatingStars
						name="satisfaccionInterior"
						nextOnClick={true}
						textGood="satisfecho/a"
						textBad="insatisfecho/a"
						CTASinRespuesta
					/>
				}
			/>
		),
		screenIndex: index++,
		name: 'satisfaccionInterior',
		outputs: ['satisfaccionInterior'],
		outputsText: ['satisfaccionInterior'],
		outputsIsStars: true,
	};

	const satisfaccionInteriorMotivo = {
		title: preguntaMotivo,
		fields: (
			<LayoutTemplate
				element={
					<DetalleMotivo
						required={true}
						name="satisfaccionInteriorMotivo"
						showRecomendation={recomendacionMotivo}
						numberOfMaxLength={300}
						CTALabel="Sin respuesta"
					/>
				}
			/>
		),
		screenIndex: index++,
		name: 'satisfaccionInteriorMotivo',
		outputs: ['satisfaccionInteriorMotivo'],
		outputsText: ['satisfaccionInteriorMotivo'],
	};

	const satisfaccionExterior = {
		title: (
			<Text bold>
				¿Qué puntuación darías al diseño exterior de tu vehículo?
			</Text>
		),
		fields: (
			<LayoutTemplate
				element={
					<RatingStars
						name="satisfaccionExterior"
						nextOnClick={true}
						textGood="satisfecho/a"
						textBad="insatisfecho/a"
						CTASinRespuesta
					/>
				}
			/>
		),
		screenIndex: index++,
		name: 'satisfaccionExterior',
		outputs: ['satisfaccionExterior'],
		outputsText: ['satisfaccionExterior'],
		outputsIsStars: true,
	};

	const satisfaccionExteriorMotivo = {
		title: preguntaMotivo,
		fields: (
			<LayoutTemplate
				element={
					<DetalleMotivo
						required={true}
						name="satisfaccionExteriorMotivo"
						showRecomendation={recomendacionMotivo}
						numberOfMaxLength={300}
						CTALabel="Sin respuesta"
					/>
				}
			/>
		),
		screenIndex: index++,
		name: 'satisfaccionExteriorMotivo',
		outputs: ['satisfaccionExteriorMotivo'],
		outputsText: ['satisfaccionExteriorMotivo'],
	};

	const satisfaccionServicioMovil = {
		title: (
			<Text bold>
				¿Cómo valoras los servicios móviles en línea (VW Connect,
				incluido el registro)?
			</Text>
		),
		fields: (
			<LayoutTemplate
				element={
					<div style={{ paddingTop: '8px' }}>
						<Text
							appearance={TokenTextAppearance.copy200}
							staticSize
						>
							Si todavía no has usado Volkswagen Connect,
							selecciona {'"Sin respuesta"'}.
						</Text>
						<RatingStars
							name="satisfaccionServicioMovil"
							nextOnClick={true}
							textGood="satisfecho/a"
							textBad="insatisfecho/a"
							CTASinRespuesta
						/>
					</div>
				}
			/>
		),
		screenIndex: index++,
		name: 'satisfaccionServicioMovil',
		outputs: ['satisfaccionServicioMovil'],
		outputsText: ['satisfaccionServicioMovil'],
		outputsIsStars: true,
	};

	const satisfaccionCalidad = {
		title: <Text bold>¿Cómo valoras la calidad de tu Volkswagen?</Text>,
		fields: (
			<LayoutTemplate
				element={
					<RatingStars
						name="satisfaccionCalidad"
						nextOnClick={true}
						textGood="satisfecho/a"
						textBad="insatisfecho/a"
						CTASinRespuesta
					/>
				}
			/>
		),
		screenIndex: index++,
		name: 'satisfaccionCalidad',
		outputs: ['satisfaccionCalidad'],
		outputsText: ['satisfaccionCalidad'],
		outputsIsStars: true,
	};

	const satisfaccionCalidadMotivo = {
		title: preguntaMotivo,
		fields: (
			<LayoutTemplate
				element={
					<DetalleMotivo
						required={true}
						name="satisfaccionCalidadMotivo"
						showRecomendation={recomendacionMotivo}
						numberOfMaxLength={300}
						CTALabel="Sin respuesta"
					/>
				}
			/>
		),
		screenIndex: index++,
		name: 'satisfaccionCalidadMotivo',
		outputs: ['satisfaccionCalidadMotivo'],
		outputsText: ['satisfaccionCalidadMotivo'],
	};

	const satisfaccionConduccion = {
		title: (
			<Text bold>
				¿Cómo de satisfecho estás con la experiencia de conducción y los
				sistemas de asistencia al conductor?
			</Text>
		),
		fields: (
			<LayoutTemplate
				element={
					<RatingStars
						name="satisfaccionConduccion"
						nextOnClick={true}
						textGood="satisfecho/a"
						textBad="insatisfecho/a"
						CTASinRespuesta
					/>
				}
			/>
		),
		screenIndex: index++,
		name: 'satisfaccionConduccion',
		outputs: ['satisfaccionConduccion'],
		outputsText: ['satisfaccionConduccion'],
		outputsIsStars: true,
	};

	const satisfaccionConduccionMotivo = {
		title: preguntaMotivo,
		fields: (
			<LayoutTemplate
				element={
					<DetalleMotivo
						required={true}
						name="satisfaccionConduccionMotivo"
						showRecomendation={recomendacionMotivo}
						numberOfMaxLength={300}
						CTALabel="Sin respuesta"
					/>
				}
			/>
		),
		screenIndex: index++,
		name: 'satisfaccionConduccionMotivo',
		outputs: ['satisfaccionConduccionMotivo'],
		outputsText: ['satisfaccionConduccionMotivo'],
	};

	const satisfaccionTecnologia = {
		title: (
			<Text bold>
				¿Cómo valoras el funcionamiento de la pantalla y los controles?
			</Text>
		),
		fields: (
			<LayoutTemplate
				element={
					<RatingStars
						name="satisfaccionTecnologia"
						nextOnClick={true}
						textGood="satisfecho/a"
						textBad="insatisfecho/a"
						CTASinRespuesta
					/>
				}
			/>
		),
		screenIndex: index++,
		name: 'satisfaccionTecnologia',
		outputs: ['satisfaccionTecnologia'],
		outputsText: ['satisfaccionTecnologia'],
		outputsIsStars: true,
	};

	const satisfaccionTecnologiaMotivo = {
		title: preguntaMotivo,
		fields: (
			<LayoutTemplate
				element={
					<DetalleMotivo
						required={true}
						name="satisfaccionTecnologiaMotivo"
						showRecomendation={recomendacionMotivo}
						numberOfMaxLength={300}
						CTALabel="Sin respuesta"
					/>
				}
			/>
		),
		screenIndex: index++,
		name: 'satisfaccionTecnologiaMotivo',
		outputs: ['satisfaccionTecnologiaMotivo'],
		outputsText: ['satisfaccionTecnologiaMotivo'],
	};

	const satisfaccionInfo = {
		title: (
			<Text bold>
				¿Cómo de satisfecho estás con el sistema de infoentretenimiento,
				incluyendo la integración del móvil?
			</Text>
		),
		fields: (
			<LayoutTemplate
				element={
					<RatingStars
						name="satisfaccionInfo"
						nextOnClick={true}
						textGood="satisfecho/a"
						textBad="insatisfecho/a"
						CTASinRespuesta
					/>
				}
			/>
		),
		screenIndex: index++,
		name: 'satisfaccionInfo',
		outputs: ['satisfaccionInfo'],
		outputsText: ['satisfaccionInfo'],
		outputsIsStars: true,
	};

	const satisfaccionInfoMotivo = {
		title: preguntaMotivo,
		fields: (
			<LayoutTemplate
				element={
					<DetalleMotivo
						required={true}
						name="satisfaccionInfoMotivo"
						showRecomendation={recomendacionMotivo}
						numberOfMaxLength={300}
						CTALabel="Sin respuesta"
					/>
				}
			/>
		),
		screenIndex: index++,
		name: 'satisfaccionInfoMotivo',
		outputs: ['satisfaccionInfoMotivo'],
		outputsText: ['satisfaccionInfoMotivo'],
	};

	const satisfaccionPrecio = {
		title: (
			<Text bold>
				¿Qué te parece la relación calidad-precio de tu coche?
			</Text>
		),
		fields: (
			<LayoutTemplate
				element={
					<RatingStars
						name="satisfaccionPrecio"
						nextOnClick={true}
						textGood="satisfecho/a"
						textBad="insatisfecho/a"
						CTASinRespuesta
					/>
				}
			/>
		),
		screenIndex: index++,
		name: 'satisfaccionPrecio',
		outputs: ['satisfaccionPrecio'],
		outputsText: ['satisfaccionPrecio'],
		outputsIsStars: true,
	};

	const satisfaccionPrecioMotivo = {
		title: preguntaMotivo,
		fields: (
			<LayoutTemplate
				element={
					<DetalleMotivo
						required={true}
						name="satisfaccionPrecioMotivo"
						showRecomendation={recomendacionMotivo}
						numberOfMaxLength={300}
						CTALabel="Sin respuesta"
					/>
				}
			/>
		),
		screenIndex: index++,
		name: 'satisfaccionPrecioMotivo',
		outputs: ['satisfaccionPrecioMotivo'],
		outputsText: ['satisfaccionPrecioMotivo'],
	};

	const satisfaccionServicioMovilMotivo = {
		title: preguntaMotivo,
		fields: (
			<LayoutTemplate
				element={
					<DetalleMotivo
						required={true}
						name="satisfaccionServicioMovilMotivo"
						showRecomendation={recomendacionMotivo}
						numberOfMaxLength={300}
						CTALabel="Sin respuesta"
					/>
				}
			/>
		),
		screenIndex: index++,
		name: 'satisfaccionServicioMovilMotivo',
		outputs: ['satisfaccionServicioMovilMotivo'],
		outputsText: ['satisfaccionServicioMovilMotivo'],
	};

	const satisfaccionAplicacion = {
		title: (
			<Text bold>¿Cómo valoras la aplicación móvil de Volkswagen?</Text>
		),
		fields: (
			<LayoutTemplate
				element={
					<div style={{ paddingTop: '8px' }}>
						<Text
							appearance={TokenTextAppearance.copy200}
							staticSize
						>
							Si todavía no has usado la aplicación móvil de
							Volkswagen, selecciona {'"Sin respuesta"'}.
						</Text>
						<RatingStars
							name="satisfaccionAplicacion"
							nextOnClick={true}
							textGood="satisfecho/a"
							textBad="insatisfecho/a"
							CTASinRespuesta
						/>
					</div>
				}
			/>
		),
		screenIndex: index++,
		name: 'satisfaccionAplicacion',
		outputs: ['satisfaccionAplicacion'],
		outputsText: ['satisfaccionAplicacion'],
		outputsIsStars: true,
	};

	const satisfaccionAplicacionMotivo = {
		title: preguntaMotivo,
		fields: (
			<LayoutTemplate
				element={
					<DetalleMotivo
						required={true}
						name="satisfaccionAplicacionMotivo"
						showRecomendation={recomendacionMotivo}
						numberOfMaxLength={300}
						CTALabel="Sin respuesta"
					/>
				}
			/>
		),
		screenIndex: index++,
		name: 'satisfaccionAplicacionMotivo',
		outputs: ['satisfaccionAplicacionMotivo'],
		outputsText: ['satisfaccionAplicacionMotivo'],
	};

	const satisfaccionGeneral = {
		title: (
			<Text bold>
				¿Y cómo de satisfecho/a estás con tu nuevo Volkswagen en
				general?
			</Text>
		),
		fields: (
			<LayoutTemplate
				element={
					<RatingStars
						name="satisfaccionGeneral"
						nextOnClick={true}
						textGood="satisfecho/a"
						textBad="insatisfecho/a"
						CTASinRespuesta
					/>
				}
			/>
		),
		screenIndex: index++,
		name: 'satisfaccionGeneral',
		outputs: ['satisfaccionGeneral'],
		outputsText: ['satisfaccionGeneral'],
		outputsIsStars: true,
	};

	const satisfaccionGeneralMotivo = {
		title: preguntaMotivo,
		fields: (
			<LayoutTemplate
				element={
					<DetalleMotivo
						required={true}
						name="satisfaccionGeneralMotivo"
						showRecomendation={recomendacionMotivo}
						numberOfMaxLength={300}
						CTALabel="Sin respuesta"
					/>
				}
			/>
		),
		screenIndex: index++,
		name: 'satisfaccionGeneralMotivo',
		outputs: ['satisfaccionGeneralMotivo'],
		outputsText: ['satisfaccionGeneralMotivo'],
	};

	const satisfaccionExperiencia = {
		title: (
			<Text bold>
				¿Hay algo más que te gustaría comentarnos sobre tu experiencia
				con tu Volkswagen?
			</Text>
		),
		fields: (
			<LayoutTemplate
				element={
					<DetalleMotivo
						required={true}
						name="satisfaccionExperiencia"
						showRecomendation={recomendacionMotivo}
						numberOfMaxLength={300}
						CTALabel="Sin respuesta"
					/>
				}
			/>
		),
		screenIndex: index++,
		name: 'satisfaccionExperiencia',
		outputs: ['satisfaccionExperiencia'],
		outputsText: ['satisfaccionExperiencia'],
	};

	const satisfaccionEntrega = {
		title: (
			<Text bold>
				¿Cuál es tu nivel de satisfacción con la ayuda que te hemos dado
				desde la entrega de tu vehículo?
			</Text>
		),
		fields: (
			<LayoutTemplate
				element={
					<RatingStars
						name="satisfaccionEntrega"
						nextOnClick={true}
						textGood="satisfecho/a"
						textBad="insatisfecho/a"
						CTASinRespuesta
					/>
				}
			/>
		),
		screenIndex: index++,
		name: 'satisfaccionEntrega',
		outputs: ['satisfaccionEntrega'],
		outputsText: ['satisfaccionEntrega'],
		outputsIsStars: true,
	};

	const grupoCliente = {
		title: (
			<Text>
				¿A qué{' '}
				<Text bold>
					grupo de clientes consideras que perteneces principalmente?
				</Text>
			</Text>
		),
		fields: (
			<LayoutTemplate
				element={
					<MultipleCTASelection
						ctaValues={ctaGruposCliente}
						name="grupoCliente"
						nextOnClick
					/>
				}
			/>
		),
		screenIndex: index++,
		name: 'grupoCliente',
		outputs: ['grupoCliente'],
		outputsText: ['grupoCliente'],
		outputsIsStars: true,
	};

	const enviarConcesion = {
		title: (
			<>
				Finalmente nos gustaría saber si podemos{' '}
				<Text bold>
					enviar tus respuestas junto con tu nombre al punto de venta{' '}
					{installation} y el bastidor del vehículo, y puedan usarlos
					para análisis adicionales.
				</Text>
			</>
		),
		fields: (
			<LayoutTemplate
				element={
					<div style={{ paddingTop: '20px' }}>
						<Text
							appearance={TokenTextAppearance.copy200}
							staticSize
						>
							Por razones técnicas las respuestas solo podrán ser
							enviadas a todas las partes involucradas a la vez.
							Si no estás de acuerdo, por favor, selecciona “No”.{' '}
						</Text>
						<RadioTextGroup
							name="enviarConcesion"
							options={optionsEnviarConcesion}
						/>
					</div>
				}
			/>
		),
		screenIndex: index++,
		name: 'enviarConcesion',
		outputs: ['enviarConcesion'],
		outputsText: ['enviarConcesion'],
		ctas: optionsEnviarConcesion,
	};

	const datosPersonales = {
		title: (
			<>
				Por favor, <Text bold>introduce o comprueba tus datos:</Text>
			</>
		),
		fields: (
			<LayoutTemplate
				element={
					<div style={{ paddingBottom: '2px' }}>
						<NombreApellidos />
					</div>
				}
			/>
		),
		screenIndex: index++,
		name: 'datosPersonales',
		outputs: ['name', 'surname', 'secondSurname'],
		outputsText: ['name', 'surname', 'secondSurname'],
	};

	const confirmacion = {
		fields: <ConfirmacionCem />,
		screenIndex: index++,
		name: 'confirmacion',
		outputs: ['confirmacion'],
		outputsText: ['confirmacion'],
	};

	const steps: Steps[] = [
		firstStep,
		confirmacionDatos,
		confirmacionConcesion,
		seleccionModelo,
		inicioRating,
		// PQ7
		satisfaccionInterior,
		satisfaccionInteriorMotivo,
		// PQ6
		satisfaccionExterior,
		satisfaccionExteriorMotivo,
		// PQ18
		satisfaccionServicioMovil,
		satisfaccionServicioMovilMotivo,
		// PQ4
		satisfaccionCalidad,
		satisfaccionCalidadMotivo,
		// PQ5
		satisfaccionConduccion,
		satisfaccionConduccionMotivo,
		// PQ12
		satisfaccionTecnologia,
		satisfaccionTecnologiaMotivo,
		// PQ 13
		satisfaccionInfo,
		satisfaccionInfoMotivo,
		// PQ19
		satisfaccionAplicacion,
		satisfaccionAplicacionMotivo,
		// PQ15
		satisfaccionPrecio,
		satisfaccionPrecioMotivo,
		// GENERAL
		satisfaccionGeneral,
		satisfaccionGeneralMotivo,
		satisfaccionExperiencia,
		satisfaccionEntrega,
		// FINAL
		grupoCliente,
		enviarConcesion,
		datosPersonales,
		confirmacion,
	];

	if (isElectrico) {
		const satisfaccionCargaPublica = {
			title: (
				<Text bold>
					¿Cómo valoras el proceso de carga en lugares públicos?
				</Text>
			),
			fields: (
				<LayoutTemplate
					element={
						<RatingStars
							name="satisfaccionCargaPublica"
							nextOnClick={true}
							textGood="satisfecho/a"
							textBad="insatisfecho/a"
							CTASinRespuesta
						/>
					}
				/>
			),
			screenIndex: index++,
			name: 'satisfaccionCargaPublica',
			outputs: ['satisfaccionCargaPublica'],
			outputsText: ['satisfaccionCargaPublica'],
			outputsIsStars: true,
		};

		const satisfaccionCargaPublicaMotivo = {
			title: preguntaMotivo,
			fields: (
				<LayoutTemplate
					element={
						<DetalleMotivo
							required={true}
							name="satisfaccionCargaPublicaMotivo"
							showRecomendation={recomendacionMotivo}
							numberOfMaxLength={300}
							CTALabel="Sin respuesta"
						/>
					}
				/>
			),
			screenIndex: index++,
			name: 'satisfaccionCargaPublicaMotivo',
			outputs: ['satisfaccionCargaPublicaMotivo'],
			outputsText: ['satisfaccionCargaPublicaMotivo'],
		};

		const satisfaccionCargaCasa = {
			title: (
				<Text bold>¿Y qué te parece el proceso de carga en casa?</Text>
			),
			fields: (
				<LayoutTemplate
					element={
						<RatingStars
							name="satisfaccionCargaCasa"
							nextOnClick={true}
							textGood="satisfecho/a"
							textBad="insatisfecho/a"
							CTASinRespuesta
						/>
					}
				/>
			),
			screenIndex: index++,
			name: 'satisfaccionCargaCasa',
			outputs: ['satisfaccionCargaCasa'],
			outputsText: ['satisfaccionCargaCasa'],
			outputsIsStars: true,
		};

		const satisfaccionCargaCasaMotivo = {
			title: preguntaMotivo,
			fields: (
				<LayoutTemplate
					element={
						<DetalleMotivo
							required={true}
							name="satisfaccionCargaCasaMotivo"
							showRecomendation={recomendacionMotivo}
							numberOfMaxLength={300}
							CTALabel="Sin respuesta"
						/>
					}
				/>
			),
			screenIndex: index++,
			name: 'satisfaccionCargaCasaMotivo',
			outputs: ['satisfaccionCargaCasaMotivo'],
			outputsText: ['satisfaccionCargaCasaMotivo'],
		};

		steps.splice(
			satisfaccionGeneral.screenIndex,
			0,
			satisfaccionCargaPublica,
			satisfaccionCargaPublicaMotivo,
			satisfaccionCargaCasa,
			satisfaccionCargaCasaMotivo,
		); // add electric questions and comments before satisfaccionGeneral
	}

	return steps;
};
